import * as React from 'react'
import cn from 'classnames'
import styles from './styles.module.scss'

type CheckinProgressIndicatorProps = {
  className?: string
  max?: number
  statusColor?: string | null
  value: string | number
}

export const CheckinProgressIndicator: React.VFC<
  CheckinProgressIndicatorProps
> = (props) => {
  const { className, max = 100, statusColor, value } = props

  return (
    <progress
      className={cn(
        'rounded w-full',
        className,
        styles['checkin-progress-bar']
      )}
      max={max}
      style={
        { '--rating-color': statusColor ?? undefined } as React.CSSProperties
      }
      value={value}
    >
      {value}%
    </progress>
  )
}
